module.exports = __webpack_public_path__ + "static/media/step_detail_career_dien_gio_mobile.64f55c45.jpg";